"use client";

import SellerProfile from "@/_pages/SellerProfile";
import UserProfile from "@/_pages/UserProfile";

/**
 * `/store/[username]` is the canonical profile route. The server resolves
 * whether the slug belongs to a seller or a plain buyer and tells us which
 * UI to mount. Both variants share the same URL — see the page comment for
 * the SEO rationale.
 */
export default function ProfileRouteClient({
  variant,
  initialSeller,
}: {
  variant: "seller" | "user";
  /** The `get_seller_profile` row the server already fetched for this page. */
  initialSeller?: Record<string, unknown> | null;
}) {
  if (variant === "seller") return <SellerProfile initialSeller={initialSeller} />;
  return <UserProfile />;
}
